import { memo, useMemo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { useEntitiesById } from "@hooks/useEntities";
import { EmptyValue } from "@design-system/EmptyValue/EmptyValue";
import { EntityAvatar } from "@components/avatar/EntityAvatar";
import { HistoryDetailsBaseRow } from "./historyDetailsBaseRow";

interface HistoryDetailsEntityCellProps {
    row: { original: HistoryDetailsBaseRow };
}

export const HistoryDetailsEntityCell = memo(
    ({ row }: HistoryDetailsEntityCellProps) => {
        const { entityId } = row.original;
        const allEntities = useEntitiesById();

        const entity = useMemo(
            () => (entityId !== null ? allEntities.get(entityId) : undefined),
            [entityId, allEntities],
        );

        if (!entity) {
            return (
                <ViewTableCell>
                    <EmptyValue />
                </ViewTableCell>
            );
        }

        return (
            <ViewTableCell>
                <EntityAvatar entity={entity} size="xs" copyId={entity.id} />
            </ViewTableCell>
        );
    },
);

HistoryDetailsEntityCell.displayName = "HistoryDetailsEntityCell";
